import { Component, EventEmitter, Input,  Output } from '@angular/core';
import { ControlValueAccessor,  NG_VALUE_ACCESSOR } from '@angular/forms';
import { Reservation } from '@app/models/micro/reservation.model';
import { GlobalsService } from '@app/services/micro/globals.service';
import { PAX_TYPE } from "@app/enums";

type sizeSwitch = 'md'| 'lg' | 'xl' | 'sm'

@Component({
    selector: 'am-input-switch',
    templateUrl: './am-input-switch.component.html',
    styleUrls: ['./am-input-switch.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: AmInputSwitchComponent,
            multi: true,
        },
    ],
    standalone: false
})
export class AmInputSwitchComponent implements ControlValueAccessor {

  /**
   * Tamaño del interruptor.
   *
   * @type {sizeSwitch}
   * @default 'md'
   */
  @Input() size: sizeSwitch = 'md';

  /**
   * Clase CSS personalizada para el contenedor del interruptor.
   *
   * @type {string}
   * @default ''
   */
  @Input() className: string = '';

  /**
   * Etiqueta del interruptor.
   *
   * @type {string}
   * @default ''
   */
  @Input() label: string = '';

  /**
   * EventEmitter que se activa cuando el estado del interruptor cambia.
   *
   * @type {EventEmitter<boolean>}
   */
  @Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
   * Indica si se debe mostrar la opción "Aplicar a todos".
   *
   * @type {boolean}
   */
  showApplyAll: boolean = false;

  /**
   * Reservación actual obtenida del servicio `GlobalsService`.
   *
   * @type {Reservation}
   */
  reservation: Reservation;

  /**
   * Valor actual del interruptor.
   *
   * @type {boolean}
   */
  val: boolean;

  /**
   * Indica si el interruptor tiene el foco.
   *
   * @type {boolean}
   */
  focusInput: boolean = false;

  @Input() isAllowedToRedeem:boolean  = false;

  ngOnInit(): void {
    this.reservation = this.global.getReservation();
    this.showApplyAll = this.countPassengerNoInfant(this.reservation.passengers) > 1 || this.isAllowedToRedeem
  }
 
  constructor(
    private global: GlobalsService
  ) {}
/**
   * Setter para el valor del interruptor.
   * Actualiza el valor y notifica los cambios a través de `onChange` y `onTouched`.
   *
   * @param {boolean} val - Nuevo valor del interruptor.
   * @return {void} No retorna ningún valor.
   */
  set value(val) {
    this.val = val
    this.onChange(val)
    if (val) {
      this.onTouched(val)
      this.focusInput = true;
    }
  }

  onChange = (value: any) => { };
  onTouched = (value: any) => { };

  writeValue(value: any): void {
    this.value = value;
  }
  /**
   * Método de la interfaz `ControlValueAccessor` que registra una función para notificar cambios en el valor del interruptor.
   *
   * @param {any} fn - Función de callback para notificar cambios.
   * @return {void} No retorna ningún valor.
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  /**
   * Método de la interfaz `ControlValueAccessor` que registra una función para notificar que el interruptor fue tocado.
   *
   * @param {any} fn - Función de callback para notificar que el interruptor fue tocado.
   * @return {void} No retorna ningún valor.
   */
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  /**
   * Método que se ejecuta cuando se hace clic en el contenedor del interruptor.
   * Cambia el estado del interruptor y emite un evento con el nuevo valor.
   *
   * @return {void} No retorna ningún valor.
   */
  onContainerClick() {
    this.value = !this.val;
    this.change.emit(this.val);
  }
  /**
   * Método que cuenta el número de pasajeros que no son infantes.
   *
   * @param {any[]} passengers - Lista de pasajeros.
   * @return {number} Número de pasajeros que no son infantes.
   */
  countPassengerNoInfant(passengers){
    let nonInfantCount = 0;

    for (const passenger of passengers) {
      if (passenger.paxType !== PAX_TYPE.INFANT) {
        nonInfantCount++;
      }
    }

    return nonInfantCount
  }


}
